import React, { useCallback, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import CheckoutSection from 'src/public/components/default_template/online_ordering/checkout/CheckoutSection'
import { OOTipSelector } from 'src/public/components/default_template/online_ordering/checkout/payment/TipSelector'
import { useCart } from 'src/public/components/online_ordering/CartContext'
import { usePayment } from 'src/public/components/online_ordering/PaymentContext'
import { Channel } from 'src/public/js/siteUtilities'
import { t } from 'src/translations'
import {
  use3pdConfig,
  useFulfillment
} from 'public/components/online_ordering/FulfillmentContext'
import { DiningOptionBehavior } from 'src/apollo/onlineOrdering'

const TipCheckoutSection = () => {
  const { tipEnabled, setTipAmount, setTipPercent } = usePayment()
  const { cart, channel } = useCart()
  const [selectedTipButton, setSelectedTipButton] = useState('')
  const { setValue } = useFormContext()
  const { uses3pd } = use3pdConfig()
  const { selectedDiningOptionBehavior } = useFulfillment()

  const isDelivery =
    selectedDiningOptionBehavior === DiningOptionBehavior.Delivery
  const is3pdDelivery = isDelivery && uses3pd

  const onTipChange = useCallback(
    (buttonId: string, tip: number, percent?: number) => {
      setSelectedTipButton(buttonId)
      setTipAmount(tip)
      setTipPercent(percent)
      // Setting a precomputed tip amount should clear the custom tip
      if (buttonId !== 'custom-tip') {
        setValue('custom-tip-amount', undefined)
      }
    },
    [setTipPercent, setTipAmount, setSelectedTipButton, setValue]
  )

  if (!cart || !tipEnabled || channel === Channel.ECOMM) {
    return null
  }

  return (
    <CheckoutSection
      title={
        is3pdDelivery
          ? t('tip-selector.add-driver-tip')
          : t('tip-selector.add-tip')
      }
    >
      <OOTipSelector
        tipOptions={cart.preComputedTips}
        selectedTipButton={selectedTipButton}
        onChange={onTipChange}
      />
    </CheckoutSection>
  )
}

export default TipCheckoutSection
